import { lazy } from "react";

const UserInformationForm = lazy(() => import("../pages/MLM/UserInformation/Form"));

const userInformationRoute = [
  {
    type: "add",
    key: Math.ceil(Math.random()) * 100000,
    path: "/user-information/add/:cellphone",
    element: <UserInformationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    type: "edit",
    key: Math.ceil(Math.random()) * 100000,
    path: "/user-information/edit/:cellphone",
    element: <UserInformationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    type: "edit",
    key: Math.ceil(Math.random()) * 100000,
    path: "/user-information/333status/:cellphone",
    element: (
      <UserInformationForm
        observe={false}
        edit={true}
        fromDraft={false}
        getByNationalCode={true}
        editHr={true}
      />
    ),
  },
  // {
  //   type: "add",
  //   key: Math.ceil(Math.random()) * 100000,
  //   path: "/JobApply/add",
  //   element: <PersonnelInformation observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   type: "add",
  //   key: Math.ceil(Math.random()) * 100000,
  //   path: "/job-apply/edit/:id",
  //   element: <PersonnelInformation observe={false} edit={false} fromDraft={false} editHr={true} />,
  // },
];

export default userInformationRoute;
